<nb-card>
  <nb-card-header>
    <span class="">Mời học viên tham gia</span>
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="form-inline" [formGroup]="diaForm">
      <nb-form-field fullWidth>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập email"
          formControlName="strSearch"
          [(ngModel)]="strSearch"
          (change)="search()"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          nbTooltip="Tra cứu"
          (click)="search()"
          [disabled]="submitted || !diaForm.valid"
          [class.btn-pulse]="submitted"
        >
          <nb-icon icon="search-outline"> </nb-icon>
        </button>
      </nb-form-field>
    </div>

    <div
      *ngIf="loadedProfile && message == ''"
      class="row"
      [nbSpinner]="loading"
      nbSpinnerStatus="info"
    >
      <div class="col-12 col-sm-6 col-md-6">
        <ngx-view-image
          [imageURL]="profile.photoURL"
          [size]="'small'"
        ></ngx-view-image>
      </div>

      <div class="col-12 col-sm-6 col-md-6">
        <nb-menu [items]="profileItems"> </nb-menu>
      </div>
    </div>

    <nb-alert *ngIf="message != ''">
      {{ message }}
    </nb-alert>
  </nb-card-body>

  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="!profile || !profile.email || message != ''"
      [class.btn-pulse]="submitted"
    >
      Mời học viên
    </button>
  </nb-card-footer>
</nb-card>
